var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "proposal-details" } }, [
    _vm.proposal
      ? _c("div", { attrs: { id: "header-area" } }, [
          _c("div", { staticClass: "header-left" }, [
            _c("div", { staticClass: "proposal-heading" }, [
              _c(
                "span",
                { staticClass: "proposal-icon" },
                [
                  _c("portal-icon", { attrs: { name: "file-check", size: 20 } })
                ],
                1
              ),
              _c("span", { staticClass: "proposal-title" }, [
                _vm._v(_vm._s(_vm.proposal.coverPage.heading))
              ])
            ]),
            _c(
              "div",
              [
                _vm.proposal
                  ? _c("comments-menu", {
                      staticClass: "mr-1",
                      attrs: {
                        comments: _vm.proposal.comments,
                        "proposal-id": _vm.proposal.id,
                        "client-id": _vm.proposal.clientId,
                        "proposal-service": _vm.proposalService,
                        "client-mode": true,
                        "viewed-timestamps": _vm.proposal.viewedTimestamps
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("div", { staticClass: "header-right" }, [
            _c(
              "button",
              {
                staticClass: "proposal-close",
                attrs: { type: "button", "aria-label": _vm.$t("global.close") },
                on: {
                  click: function($event) {
                    return _vm.handleClose()
                  }
                }
              },
              [_c("portal-icon", { attrs: { name: "x", size: 20 } })],
              1
            )
          ])
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "proposal-document show-scrollbar" },
      [
        _vm.isReady
          ? _c("proposal-renderer", {
              attrs: {
                proposal: _vm.proposal,
                account: _vm.account,
                "proposal-service": _vm.proposalService,
                "edit-mode": false,
                "pod-service": null,
                "client-service": null,
                "need-save": false,
                saving: false,
                "client-mode": true,
                "is-locked": _vm.isLocked,
                "card-payment-failed": _vm.cardPaymentFailed
              },
              on: {
                "deliverable-selected": function($event) {
                  return _vm.deliverableSelected($event)
                },
                "client-signed": function($event) {
                  return _vm.clientFinalized($event)
                },
                "client-accepted": function($event) {
                  return _vm.clientFinalized($event)
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }